import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './components/Home';
import About from './components/About';
import Services from './components/Services';
import Contact from './components/Contact';
import Dashboard from './components/Dashboard';
import DashboardHome from './components/DashboardHome';
import DashboardNews from './components/DashboardNews';
import DashboardContact from './components/DashboardContact';
import BookSchedule from './components/BookSchedule';
import Admin from './components/Admin';
import BlogList from './components/BlogList';
import SingleBlog from './components/SingleBlog';
import DashboardBlog from './components/DashboardBlog';
import DashboardBooking from './components/DashboardBooking';
import ProtectedRoute from './components/ProtectedRoute.js';
import ScrollToTop from './components/ScrollToTop.js';
import DashboardServices from './components/DashboardServices.js';
const Layout = () => {
  const location = useLocation();
  const hideDashboard = 
    location.pathname === '/dashboard' || 
    location.pathname === '/dashboard/news' || 
    location.pathname === '/dashboard/contact' || 
    location.pathname === '/dashboard/schedule' ||
    location.pathname === '/dashboard/blogs' ||
    location.pathname === '/dashboard/bookings' ||
    location.pathname === '/dashboard/services' ||
    location.pathname === '/admin';
  
  return (
    <>
      {!hideDashboard && <Header />}
      
      <main style={{ minHeight: '80vh' }}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/blogs" element={<BlogList />} />
          <Route path="/blog/:slug" element={<SingleBlog />} />
          {/* Services Routes */}
          <Route path="/services" element={<Services />} />
         
          {/* Dashboard Routes */}
        <Route
          path="/dashboard/*"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        >
            <Route index element={<DashboardHome />} />
            <Route path="services" element={<DashboardServices />} />

            <Route path="blogs" element={<DashboardBlog />} />
            <Route path="news" element={<DashboardNews />} />
            <Route path="schedule" element={<BookSchedule />} />
             <Route path="bookings" element={<DashboardBooking />} />
            <Route path="contact" element={<DashboardContact />} />
          </Route>
        </Routes>
      </main>

      {!hideDashboard && <Footer />}
    </> 
  );
};

const App = () => {
  return (
    <Router>
       <ScrollToTop />
      <Layout />
    </Router>
  );
};

export default App;